import { MouseEvent } from "react";

import { IconButton } from "@/DesignSystem";

import GearFillIcon from "@/DesignSystem/Atoms/Icons/Types/Gear/gear-fill.svg";

interface FilterSettingsIconButtonProps {
    careComponentName: string;
    size?: "sm" | "md";
    onClick: (e: MouseEvent<HTMLButtonElement>) => void;
}

function FilterSettingsIconButton({
    careComponentName,
    size = "md",
    onClick
}: FilterSettingsIconButtonProps): JSX.Element {
    return (
        <IconButton
            key={`${careComponentName}_iconButton`}
            variant="neutral"
            category="secondary"
            size={size}
            onClick={onClick}
        >
            <GearFillIcon />
        </IconButton>
    );
}

export { FilterSettingsIconButton };
